import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import { AutoComplete } from 'redux-form-material-ui';
import MUIAutoComplete from 'material-ui/AutoComplete';
import { reduxForm, Field } from 'redux-form';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import { translate } from 'react-i18next';

import i18n from '../translations/i18n';

/*
  Styled components
 */
const ButtonContainer = styled.div`
  margin-top: 30;
  float: right;
`;

const StyledSubmitButton = styled(RaisedButton)`
  margin-left: 5px !important;
`;

/*
  PropTypes / DefaultProps
 */
const propTypes = {
  isModify: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  endUsers: PropTypes.any,
  packetboxes: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {
  isModify: false,
};

function EndUserKeyForm(props) {
  const { handleSubmit, endUsers, packetboxes } = props;

  const dataSourceConfig = {
    text: 'text',
    value: 'value',
  };

  const customerDataSource = endUsers.filter(enduser => enduser.valid).map(endUser => ({
    text: `${endUser.full_name} (${endUser.username})`,
    value: endUser.id,
  }));

  const packetboxDataSource = packetboxes.filter(pkb => pkb.is_active).map(packetbox => ({
    text: `${packetbox.name} - (${packetbox.owner___first_name} ${
      packetbox.owner___last_name
    }, ${packetbox.street || ''} ${packetbox.street_number || ''}, ${packetbox.place || ''})`,
    value: packetbox.id,
  }));

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12">
          <div className="box">
            <Field
              component={AutoComplete}
              name="consumer_id"
              openOnFocus
              filter={MUIAutoComplete.caseInsensitiveFilter}
              dataSourceConfig={dataSourceConfig}
              dataSource={customerDataSource}
              hintText={props.t('consumer')}
              floatingLabelText={props.t('consumer')}
              searchText=""
              fullWidth
            />

            <Field
              component={AutoComplete}
              name="paketbox_id"
              openOnFocus
              filter={MUIAutoComplete.caseInsensitiveFilter}
              dataSourceConfig={dataSourceConfig}
              dataSource={packetboxDataSource}
              hintText={props.t('paketbox')}
              floatingLabelText={props.t('paketbox')}
              searchText=""
              fullWidth
            />
          </div>
        </div>
      </div>
      <ButtonContainer>
        <Link onClick={browserHistory.goBack}>
          <RaisedButton label={props.t('back')} />
        </Link>

        <StyledSubmitButton label={props.t('save')} type="submit" primary />
      </ButtonContainer>
    </form>
  );
}
EndUserKeyForm.propTypes = propTypes;
EndUserKeyForm.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(EndUserKeyForm);
export default reduxForm({ form: 'endUser' })(localize(extended, 'locale'));



// WEBPACK FOOTER //
// ./src/components/EndUserKeyForm.js